import * as React from "react";
import {connect} from "react-redux";
import {none, option, Option} from "ts-option";
import Brand from "../../model/brand/Brand";
import {RootState} from "../../store/reducer/root/RootState";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import IndividualContact from "../../model/contact/IndividualContact";

interface ComponentProps {
	/**
	 * Contact.
	 */
	contact: Option<IndividualContact>
}

interface ReduxProps {
	/**
	 * Selected brand.
	 */
	brand: Option<Brand>;
}

type Props = ComponentProps & ReduxProps

/**
 * Job brand displayer.
 */
class BrandDisplayer extends React.PureComponent<Props, {}> {

	render() {
		return this.props.brand.map(brand => {
			return (
				<InfoModule icon={Icon.Job} title={"Brand"}>
					<span className="t-body">{brand.name}</span>
				</InfoModule>
			);
		}).orNull
	}
}

function mapStateToProps(state: RootState, componentProps: ComponentProps) {
	if (componentProps.contact.map(c => c.data.brandId).isEmpty) {
		return {brand: none}
	}
	const brands = state.brand.brands.getOrElse([]);
	const brand = brands.filter(item => item.id === componentProps.contact.map(c => c.data.brandId).get)[0];
	return {
		brand: option(brand)
	};
}

export default connect(mapStateToProps)(BrandDisplayer)
